import { createStyles, Theme } from '@material-ui/core'

const navigationStyles = (theme: Theme) =>
  createStyles({
    root: {},
    menuItems: {
      flex: 1,
      flexGrow: 1,
      alignItems: 'center'
    },
    menuButton: {
      marginLeft: 10,
      [theme.breakpoints.down(450)]: {
        marginLeft: -3,
      }
    },
    menuItem: {
      [theme.breakpoints.up('md')]: {
        paddingLeft: 5,
        paddingRight: 5,
        height: 17
      }
    },
    desktopMenu: {
      display: 'none',
      color: '#fff',
      [theme.breakpoints.up('md')]: {
        maxWidth: '500px',
        flexWrap: 'nowrap',
        flexGrow: 1,
        display: 'contents'
      }
    },
    mobileMenu: {
      display: 'flex',
      [theme.breakpoints.up(1066)]: {
        display: 'none'
      }
    },
    hide: {
      display: 'none'
    },
    appBar: {
      backgroundColor: '#94004A',
      marginTop: '0px',
      color: '#fff',
      boxShadow: 'none !important',
      zIndex: theme.zIndex.drawer + 1,
      minHeight: '69px'
    },
    drawerPaper: {
      whiteSpace: 'nowrap',
      maxHeight: '70vh',
      minHeight: '60vh',
      [theme.breakpoints.up(1066)]: {
        display: 'none'
      }
    },
    toolbar: {
      marginTop: '0px',
      minHeight: '69px',
      height: '69px',
      width: '100%',
      maxWidth: '100vw'
    },
    navToolbar: {
      height: '69px',
      alignItems: 'stretch',
      [theme.breakpoints.up('md')]: {
        marginTop: '0px'
      }
    },
    content: {
      '@supports (-webkit-touch-callout: none)': {
        height: 'calc(100vh - 69px)'
      },
      flexGrow: 1,
      height: '100vh',
      width: '100vw',
      '@media (min-width: 960px)': {
        overflowY: 'auto',
        overflowX: 'hidden'
      }
    },
    containerHolder: {
      /* Commenting this out to allow full screen banners */
      // width: '99vw', // necessary! leaves room for scrollbar and prevents shaking fix
      margin: '0px auto'
    },
    spacing: {
      padding: '20px 0 20px 0'
    },
    button: {
      color: 'white',
      textDecoration: 'none'
    },
    adminHeader: {
      color: 'white',
      padding: 10,
      marginRight: 10
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      margin: 0,
      height: 'auto',
      flex: '0 0 auto',
    },

    logo: {
      display: 'block',        // removes baseline gap from inline images
      height: '45px',          // desktop default
      width: 'auto',
      objectFit: 'contain',
      margin: 0,
      marginRight: '20px',
      [theme.breakpoints.down('sm')]: {
        height: '40px',
      },
      [theme.breakpoints.down('xs')]: {
        //height: '32x',
        marginRight: '3px',
      },
    },

    link: {
      textDecoration: 'none'
    },
    phoneNumberDiv: {
      marginLeft: '10px',
      [theme.breakpoints.down('xs')]: {
        position: 'absolute',
        top: '38%',
        left: '36%',
        marginLeft: '0px'
      }
    },
    phoneNumberTextDiv: {
      marginLeft: '5px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '-3px',
        '@media (max-width: 380px)': {
          marginLeft: '0'
        }
      }
    },
    suggestContainer: {
      background: '#FBF6EE',
      padding: '25px 40px',
      display: 'flex',
      fontSize: '12px',
      borderRadius: '25px',
      maxWidth: '800px',
      [theme.breakpoints.up('xs')]: {
        padding: '25px'
      },
      '& img': {
        marginRight: '10px'
      }
    },
    largeForm: {
      float: 'left',
      padding: '35px 0 15px 0',
      maxWidth: '800px',
      width: '100%',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        padding: '10px 0'
      },
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        maxWidth: '800px'
      }
    },
    suggestDialogContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    buttonContainerClassName: {
      flex: '1 1 auto',
      margin: '10px 0 25px 0',
      display: 'flex',
      justifyContent: 'center'
    },
    buttonConfirmClassName: {
      width: '100%',
      marginLeft: '10px',
      textTransform: 'none',
      color: '#ffffff',
      backgroundColor: '#94004A',
      '&:hover': {
        backgroundColor: '#670033'
      }
    },
    buttonCloseClassName: {
      marginRight: '10px',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
      width: '100%',
      textTransform: 'none',
      color: '#000000',
      '&:hover': {
        backgroundColor: '#d3d3d3'
      }
    },
    titlePopup: {
      textAlign: 'center',
      fontSize: '1.2rem'
    },
    dialogSaveBtn: {
      font: '13px CircularRegular',
      borderRadius: '10px',
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
      padding: '15px 0',
      color: '#2f2f2f',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
      textTransform: 'none' as const
    },
    modalTitle: {
      paddingTop: '5px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.2rem'
      }
    },
    primaryBtn: {
      font: '13px CircularRegular',
      borderRadius: '10px',
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
      backgroundColor: '#94004A',
      padding: '15px 0',
      color: '#fff',
      marginBottom: '15px',
      '&:hover': {
        backgroundColor: '#670033'
      }
    },
    mobileBottomNavWrapper: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.drawer + 2,
      backgroundColor: '#fff',
      boxShadow: '0px -4px 16px rgba(0, 0, 0, 0.08)'
    },
    mobileBottomNav: {
      borderTop: '1px solid rgba(0, 0, 0, 0.08)',
      backgroundColor: 'transparent',
      paddingBottom: 'max(env(safe-area-inset-bottom), 6px)'
    },
    mobileBottomNavActionRoot: {
      minWidth: 0,
      flex: 1,
      color: '#5D305C',
      padding: '8px 0 2px 0',
      '&.Mui-selected': {
        padding: '8px 0 2px 0'
      }
    },
    mobileBottomNavActionSelected: {
      color: '#920049 !important'
    },
    mobileBottomNavActionLabel: {
      fontSize: '0.7rem',
      letterSpacing: 0.25,
      '&.Mui-selected': {
        fontSize: '0.7rem',
        fontWeight: 500
      }
    },
    mobileBottomNavIcon: {
      width: 24,
      height: 24,
      display: 'block',
      margin: '0 auto'
    },
    mobileBottomNavSpacer: {
      height: 'calc(82px + env(safe-area-inset-bottom))'
    }
  })

export default navigationStyles
